import template from 'employer/templates/payroll/stepOne/EmployeeList.html';
import EmployeeView from './Employee';
import PayrollDetails from 'newCollections/payroll-details.js';
import PaginatedList from 'commons/views/PaginatedList.js';

module.exports = PaginatedList.extend({

    events: function() {
        const myEvents = {
            'click .js-payroll-toggle': 'payrollToggle'
        };
        return Object.assign(
            myEvents,
            PaginatedList.prototype.events.apply(this)
        );
    },

    initialize: function(options) {
        this.detailViews = [];

        this.options = _.defaults(options || {}, {
            employees: null,
            payroll: null,
            payrollDetails: null,
            lastPayrollDetails: null,
            lastPayroll: null,
            payrollItems: null,
            layoutView: null
        });

        this.collection = this.options.employees;
        this.collection.on('sync', this.render, this);
    },

    render: function() {
        const pagination = this.collection.pagination;
        this.$el.html(template({pagination}));

        this.$('.js-empty-list').toggleClass(
            'hidden', (this.collection.length > 0)
        );

        this.options.layoutView.showLoader();
        return this.fetchDetails(this.collection).then(() => {
            return Promise.each(this.collection.models, employee => {
                var detailView = new EmployeeView({
                    model: employee,
                    payroll: this.options.payroll,
                    payrollDetails: this.options.payrollDetails,
                    payrollItems: this.options.payrollItems,
                    lastPayrollDetails: this.options.lastPayrollDetails,
                    className: 'employee footable-employee ' +
                        'toggle-arrow-tiny'
                });

                this.detailViews.push(detailView);
                this.$('.js-payroll-details')
                    .append(detailView.el);
            });
        }).finally(() => {
            this.show();
            this.options.layoutView.hideLoader();
        });
    },

    payrollToggle: function(e) {
        e.preventDefault();

        if (this.collapsed) {
            this.$('.footable').trigger('footable_expand_all');
            this.collapsed = false;
        } else {
            this.$('.footable').trigger('footable_collapse_all');
            this.collapsed = true;
        }
    },

    show: function() {
        _.each(this.detailViews, function(view) {
            view.$el.trigger('show');
        });
    },

    activate: function() {
        if (this.detailViews.length !== 0) {
            return;
        }
        this.render();
    },

    remove: function() {
        Backbone.View.prototype.remove.apply(this, arguments);

        this.undelegateEvents();
        _.each(this.detailViews, function(view, i) {
            view.remove();
            delete this.detailViews[i];
        }.bind(this));
    },

    confirmMissingEmployees: function() {
        // By default include all employees to the payroll
        return Promise.resolve(true);
    },

    fetchDetails: function(employees) {
        const payroll = this.options.payroll;
        const lastPayroll = this.options.lastPayroll;
        let detailsPromise;
        let lastDetailsPromise;

        if (!employees.length) {
            return;
        }

        const fetchDetailsForPayroll = (payroll, employees) =>
            new PayrollDetails(null, {payroll}).fetch({
                filter: {
                    limit: 9999,
                    where: {
                        employeeId: {
                            inq: employees
                                .map(employee => employee.get('objectId'))
                        }
                    }
                }
            })
            .then(collection => collection.filterNonContributions());

        let employeesWithoutDetails = employees.filter(employee => {
            return this
                .options
                .payrollDetails
                .filterByEmployee(employee.id)
                .length === 0;
        });
        const employeesWithoutLastDetails = employees.filter(employee => {
            return this
                .options
                .lastPayrollDetails
                .filterByEmployee(employee.id)
                .length === 0;
        });

        if (employeesWithoutDetails.length === 0) {
            detailsPromise = Promise.resolve([]);
        } else {
            if (payroll.isNew()) {
                detailsPromise = PayrollDetails.createDefaults(
                    payroll, employeesWithoutDetails
                );
            } else {
                detailsPromise = fetchDetailsForPayroll(payroll, employees)
                    .then(collection => {
                        collection.models.forEach(detail => {
                            this.options.payrollDetails.add(detail);
                        });
                        const employeesWithDetails = collection
                            .map(details => details.get('employeeId'));

                        employeesWithoutDetails = employees.filter((emp) => (
                            !employeesWithDetails.includes(emp.id))
                        );

                        if (employeesWithoutDetails.length === 0) {
                            return Promise.resolve([]);
                        } else {
                            return PayrollDetails.createDefaults(
                                payroll, employeesWithoutDetails
                            );
                        }
                    });
            }
        }

        if (employeesWithoutLastDetails.length === 0 || !lastPayroll) {
            lastDetailsPromise = Promise.resolve([]);
        } else {
            lastDetailsPromise = fetchDetailsForPayroll(
                lastPayroll, employeesWithoutLastDetails
            );
        }

        return Promise.all([
            detailsPromise.then(collection => {
                if (collection.length > 0) {
                    collection.models.forEach(detail => {
                        this.options.payrollDetails.add(detail);
                    });
                }
            }),
            lastDetailsPromise
                .then(collection => {
                    if (collection.length > 0) {
                        collection.models.forEach(detail => {
                            if (detail.get('amount') > 0) {
                                this.options.lastPayrollDetails.add(detail);
                            }
                        });
                    }
                })
        ]);
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/payroll/stepOne/EmployeeList.js